export enum PrescriptionTypeEnum {
  all = 0,
  patient,
  doctor,
  admin
}
